import { render } from "./phaseLogin.vue?vue&type=template&id=2e6f4031"
import script from "./phaseLogin.vue?vue&type=script&lang=js"
export * from "./phaseLogin.vue?vue&type=script&lang=js"

import "./phaseLogin.vue?vue&type=style&index=0&id=2e6f4031&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__